<ng-container *ngIf="dashboardService.sideBarState$ | async as sidebar">
    <div class="reporting-container" *ngIf="!(sidebar?.isSideBarCollapsed || sidebar?.isSidebarCollapsed)">
        <app-reporting-controls></app-reporting-controls>
    </div>
</ng-container>
